__turbopack_context__.v({
  "arrow": "style-module-scss-module__TG5epG__arrow",
  "component": "style-module-scss-module__TG5epG__component",
  "fill": "style-module-scss-module__TG5epG__fill",
  "label": "style-module-scss-module__TG5epG__label",
  "meta": "style-module-scss-module__TG5epG__meta",
  "row": "style-module-scss-module__TG5epG__row",
  "rowContent": "style-module-scss-module__TG5epG__rowContent",
  "rowHeader": "style-module-scss-module__TG5epG__rowHeader",
  "rowLink": "style-module-scss-module__TG5epG__rowLink",
  "track": "style-module-scss-module__TG5epG__track",
});
